import {
    CHART_TYPE_DAYS_ON_MARKET,
    CHART_TYPE_HOME_PRICE,
    CHART_TYPE_INVENTORY,
    CHART_TYPE_NEW_LISTINGS,
    CHART_TYPE_PRICE_VS_INVENTORY,
    TREND_DOWN,
    TREND_STEADY,
    TREND_UP,
} from './captions';

const STEADY_THRESHOLD = 0.03;

const MONTH_LABELS = [
    "Aug '24", "Sep '24", "Oct '24", "Nov '24", "Dec '24", "Jan '25",
    "Feb '25", "Mar '25", "Apr '25", "May '25", "Jun '25", "Jul '25",
];

function getTrend(current, prior) {
    const delta = (current - prior) / prior;
    if (Math.abs(delta) <= STEADY_THRESHOLD) return TREND_STEADY;
    return delta > 0 ? TREND_UP : TREND_DOWN;
}

function ramp(prior, current, amplitude = 0.04) {
    const count = MONTH_LABELS.length;

    return Array.from({ length: count }, (item, index)=> {
        if (index === count - 1) return current;
        const t = index / (count - 1);
        const base = prior + (current - prior) * t;
        return Math.round(base * (1 + amplitude * Math.sin(index * 1.15)));
    });
}

function metric(current, prior) {
    return { current, prior, trend: getTrend(current, prior) };
}

function buildData({ chartType, areaLabel = 'United States', price, inventory }) {
    const primaryValues = ramp(price.prior, price.current);
    const secondaryValues = inventory ? ramp(inventory.prior, inventory.current, 0.05) : null;

    return {
        chartType,
        areaLabel,
        source: 'Realtor.com®',
        series: MONTH_LABELS.map((label, index)=> ({
            label,
            primary: primaryValues[index],
            ...(secondaryValues ? { secondary: secondaryValues[index] } : {}),
        })),
        primary: metric(price.current, price.prior),
        secondary: inventory ? metric(inventory.current, inventory.prior) : null,
    };
}

const MARKET_TOPIC_FIXTURES = [
    {
        chartType: CHART_TYPE_DAYS_ON_MARKET,
        label: 'Days on Market',
        price: { current: 62, prior: 47 },
    },
    {
        chartType: CHART_TYPE_INVENTORY,
        label: 'Active Listings',
        price: { current: 13250, prior: 9800 },
    },
    {
        chartType: CHART_TYPE_NEW_LISTINGS,
        label: 'New Listings',
        price: { current: 3200, prior: 2400 },
    },
    {
        chartType: CHART_TYPE_HOME_PRICE,
        label: 'Median Listing Price',
        price: { current: 432000, prior: 398000 },
    },
    {
        chartType: CHART_TYPE_PRICE_VS_INVENTORY,
        label: 'Price vs Inventory',
        price: { current: 432000, prior: 398000 },
        inventory: { current: 720000, prior: 890000 },
    },
];

function toTestPath(data) {
    return `/housing_snapshot_shareable?data=${encodeURIComponent(JSON.stringify(data))}`;
}

export const housingSnapshotTestPaths = MARKET_TOPIC_FIXTURES.map(({ chartType, label, price, inventory })=> ({
    name: `Market Snapshot - ${label}`,
    testPath: toTestPath(buildData({ chartType, price, inventory })),
}));
